export default __webpack_public_path__ + "static/media/LOGO-1.1f422c70.png";